import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProjectPage from '../pages/ProjectPage';
import NotFound from '../pages/NotFound';
import FastTrack from '../pages/FastTrack';
import Intake from '../pages/Intake';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import Breadcrumb from '../components/Breadcrumb';
import './App.css';
import {ROUTES} from '../constants'

const App = () => {
  console.log('[APP] REACT_APP_ADLS_ENDPOINT:', process.env.REACT_APP_ADLS_ENDPOINT);
  if (!process.env.REACT_APP_ADLS_ENDPOINT) {
    console.warn('REACT_APP_ADLS_ENDPOINT is not defined in environment variables');
  }

  return(
    <>
      <div className="app">
        <Header />
        <Breadcrumb />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<FastTrack />} />
            <Route path="/intake" element={<Intake />} />
            {ROUTES.map((route) => (
              <Route
                key={route.path}
                path={`${route.path}`}
                element={<ProjectPage endpoint={`${process.env.REACT_APP_ADLS_ENDPOINT}${route.endpoint}`} />}
              />
            ))}
            <Route path="*" element={<NotFound/>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  )
};

export default App;